module.exports = __webpack_public_path__ + "4608f5a70ee122603822272bcdcdbca1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-kawauso-omedetou-gozaimasu.png
// module id = 2044
// module chunks = 4